import React from 'react';
import { List, Datagrid, TextField } from 'react-admin';


export const ShiftDailyList = props => (
  <List {...props} >
    <Datagrid  >
      <TextField source="id" />
      <TextField source="description" />
    </Datagrid>
</List>
);

export default ShiftDailyList